import React from 'react';
import { Modal } from 'react-native';
import type { ModalProps } from 'react-native';
import ScreenEdgeBack, { useBlockAncestorEdgeBack } from './ChatEdgeBack';

// Only full-screen pages gain edge Back. Sheets, confirmation dialogs and
// native presentation gestures retain their existing dismissal behavior.
export default function ScreenModal({ children, ...props }: ModalProps) {
  useBlockAncestorEdgeBack(props.visible !== false);
  const fullScreen = !props.transparent &&
    (!props.presentationStyle || props.presentationStyle === 'fullScreen');
  return <Modal {...props}>
    {fullScreen && props.onRequestClose
      ? <ScreenEdgeBack captureEdgeOnStart enabled={props.visible !== false} onBack={props.onRequestClose}>
          {children}
        </ScreenEdgeBack>
      : children}
  </Modal>;
}
